import { Link } from "react-router"
import { Eyebrow, PageHero } from "./components"

const PILLARS = [
  {
    icon: "fundamentals",
    title: "Business fundamentals",
    body: "Bookkeeping, pricing, savings, and the basics of running a stall like a business — not a scramble.",
  },
  {
    icon: "grants",
    title: "Micro-grants",
    body: "Small starter grants for cohort graduates, so a plan on paper becomes stock on a table.",
  },
  {
    icon: "cohorts",
    title: "Peer cohorts",
    body: "Women learn in groups of 10–15 that keep meeting after graduation — accountability that sticks.",
  },
  {
    icon: "growth",
    title: "Growth coaching",
    body: "Quarterly check-ins to reinvest profit, expand product lines, and formalize the enterprise.",
  },
]

const VOICES = [
  {
    quote: "“I used to guess my prices. Now I know my margin — and my son's school fees are paid on time.”",
    name: "Chiamaka",
    role: "Kiosk owner, Port Harcourt",
  },
  {
    quote: "“The grant bought my second machine. I trained two apprentices this year.”",
    name: "Ijeoma",
    role: "Tailor, Rumuola",
  },
  {
    quote: "“Fifty birds became two hundred. The cohort still calls me every Sunday.”",
    name: "Blessing",
    role: "Poultry, Igwuruta",
  },
]

function PillarIcon({ type }: { type: string }) {
  const paths = {
    fundamentals: <>
      <path d="M17.0794 6.53297L15.4953 4.94738C14.2496 3.70049 12.5601 3 10.7985 3C9.95307 3 9.5297 4.02309 10.1275 4.62145L10.5245 5.01883C11.9169 6.41256 11.9169 8.67222 10.5245 10.0659L13.0456 12.5895L14.5583 11.0754L16.0709 12.5895C15.514 13.147 15.514 14.0508 16.0709 14.6083L16.5752 15.113C16.9876 15.5258 17.1938 15.7322 17.4162 15.8426C17.8394 16.0525 18.3363 16.0525 18.7595 15.8426C18.9819 15.7322 19.1881 15.5258 19.6005 15.113L21.1132 13.5989C21.5256 13.1861 21.7318 12.9797 21.842 12.7571C22.0517 12.3335 22.0517 11.8361 21.842 11.4125C21.7318 11.1898 21.5256 10.9834 21.1132 10.5706L20.6089 10.0659C20.052 9.50845 19.149 9.50845 18.592 10.0659L17.0794 8.55181C17.6363 7.99432 17.6363 7.09046 17.0794 6.53297Z" />
      <path d="M10.6074 10L2.52431 17.9822C2.1886 18.3138 2 18.7634 2 19.2322C2 20.2085 2.80146 21 3.7901 21C4.26487 21 4.72019 20.8138 5.0559 20.4822L13.6453 12" />
    </>,
    grants: <>
      <path d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z" />
      <path d="M13.4368 9.55807L10.6 12M10.6 12L7 15M10.6 12L13.4949 14.3865M10.6 12L7 9M16 8.5C16 9.32843 15.3284 10 14.5 10C13.6716 10 13 9.32843 13 8.5C13 7.67157 13.6716 7 14.5 7C15.3284 7 16 7.67157 16 8.5ZM16 15.5C16 16.3284 15.3284 17 14.5 17C13.6716 17 13 16.3284 13 15.5C13 14.6716 13.6716 14 14.5 14C15.3284 14 16 14.6716 16 15.5Z" />
    </>,
    cohorts: <>
      <path d="M7.64584 15.7108C7.23279 14.8966 7 13.9755 7 13C7 9.78484 9.5 7.5 13 7C17.0817 6.4169 18.8333 4.16667 20 3C23.5 16 17 19 13 19C11.9071 19 10.8825 18.7078 10 18.1973" />
      <path d="M3 21C3.5 18 5.45791 16.1355 10 15C13.2167 14.1958 15.4634 12.1791 17 10.0549" />
    </>,
    growth: <>
      <path d="M4 14H22" />
      <path d="M5 22L5.93056 21.0694C6.45933 20.5407 6.72371 20.2763 7.05684 20.126C7.38997 19.9756 7.76314 19.9523 8.50947 19.9057L11.7619 19.7024C13.3604 19.6025 14.1597 19.5525 14.863 19.2148C15.5664 18.877 16.1051 18.2844 17.1824 17.0993L20 14H16.5L14.7071 15.7929C14.5879 15.9121 14.5282 15.9718 14.4662 16.0244C14.1472 16.2954 13.7512 16.4594 13.3341 16.4934C13.2529 16.5 13.1686 16.5 13 16.5M13 16.5C13 16.0353 13 15.803 12.9616 15.6098C12.8038 14.8164 12.1836 14.1962 11.3902 14.0384C11.197 14 10.9647 14 10.5 14H9.71849C8.67345 14 8.15093 14 7.66095 14.126C7.29599 14.2198 6.94612 14.3647 6.62171 14.5564C6.18617 14.8138 5.81669 15.1833 5.07774 15.9223L2 19M13 16.5H9.5" />
      <path d="M5 11.5C5 7.08171 8.58171 3.5 13 3.5M13 3.5C17.4183 3.5 21 7.08171 21 11.5M13 3.5V2" />
    </>,
  } as const

  return (
    <span className="womens-pillar-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        {paths[type as keyof typeof paths]}
      </svg>
    </span>
  )
}

export function WomensEmpowermentPage() {
  return (
    <div className="womens-empowerment-page">
      <PageHero
        className="womens-hero"
        eyebrow="Alongside the Children"
        eyebrowDot
        title={<>The women who <span className="text-forest-700">hold it all up.</span></>}
        lede="A child stays in school more easily when the home stays steady. So we train and equip the women in our scholars' lives — mothers, guardians, aunts — to run their small enterprises like real businesses."
      />

      <section className="womens-story-section bg-cream-50">
        <div className="public-container">
          <div className="womens-story-grid">
            <img
              src="/images/pages/programs-skills.jpg"
              alt="A woman at work in her small enterprise"
              loading="lazy"
              className="womens-story-image order-2 w-full rounded-2xl object-cover lg:order-1"
            />
            <div className="womens-story-copy order-1 lg:order-2">
              <Eyebrow dot>Why This Matters</Eyebrow>
              <h2 className="mt-4 font-display text-[30px] font-bold leading-tight text-ink sm:text-[40px] lg:text-[48px]">
                A steady home <span className="text-forest-700">keeps a scholar in class.</span>
              </h2>
              <p className="mt-5 text-lg leading-relaxed text-ink/80">
                When a woman&apos;s trade grows from survival to enterprise, the whole household shifts. School fees stop being a monthly crisis. Uniforms fit. Homework happens in a lit room. This is upstream work for the same downstream goal — every child, in school.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="womens-program-section bg-cream-50">
        <div className="public-container">
          <Eyebrow dot>The Program</Eyebrow>
          <h2 className="mt-4 font-display text-[30px] font-bold leading-tight text-ink sm:text-[40px] lg:text-[48px]">
            Four pillars.
          </h2>
          <div className="womens-pillar-grid mt-8 grid grid-cols-2 gap-4 lg:mt-12 lg:grid-cols-4 lg:gap-[10px]">
            {PILLARS.map((pillar) => (
              <article key={pillar.title} className="womens-pillar-card min-h-[150px] rounded-xl bg-white p-4 lg:h-[224px] lg:rounded-[20px] lg:p-6">
                <PillarIcon type={pillar.icon} />
                <h3 className="text-sm font-semibold text-ink lg:text-base">{pillar.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-ink/70 lg:mt-3 lg:text-[15px]">{pillar.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="womens-voices-section bg-cream-50">
        <div className="public-container">
          <Eyebrow dot>Voices from the Cohort</Eyebrow>
          <h2 className="mt-4 font-display text-[30px] font-bold leading-tight text-ink sm:text-[40px] lg:text-[48px]">
            Small businesses. <span className="text-forest-700">Steady homes.</span>
          </h2>
          <div className="mt-8 grid gap-4 md:grid-cols-3 lg:mt-12 lg:gap-[10px]">
            {VOICES.map((voice) => (
              <figure key={voice.name} className="womens-voice-card flex h-full min-h-[150px] flex-col rounded-2xl bg-white p-5 lg:h-[176px] lg:min-h-0 lg:p-7">
                <blockquote className="text-sm leading-relaxed text-ink lg:text-[15px]">{voice.quote}</blockquote>
                <figcaption className="mt-auto flex flex-col pt-4 text-sm text-ink lg:pt-6 lg:text-base">
                  <strong>{voice.name}</strong>
                  <span>{voice.role}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="womens-cta bg-cream-50">
        <div className="public-container">
          <div className="womens-cta-content">
            <h2>
              Partner with the <span className="text-forest-700">women&apos;s program.</span>
            </h2>
            <p>
              Fund a cohort, sponsor a grant, or bring your expertise as a business mentor. Every angle helps a household stay whole.
            </p>
            <div className="womens-cta-actions">
              <Link className="womens-cta-primary" to="/contact">Coming soon</Link>
              <Link className="womens-cta-secondary" to="/about">Back to our story</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
